import Dashboard from "../layouts/Dashboard.jsx";
import Pages from "../layouts/Pages.jsx";

var indexRoutes = [
  // { path: "/loading", name: "Loading", component: Loading },
  { path: "/pages", name: "Pages", component: Pages },
  { path: "/", name: "Home", component: Dashboard },
];

export default indexRoutes;
